/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_main_colors_brown5 = /** @type {(inputs: {}) => string} */ () => {
	return `Hnědá`
};

const da_main_colors_brown5 = /** @type {(inputs: {}) => string} */ () => {
	return `Brun`
};

const de_main_colors_brown5 = /** @type {(inputs: {}) => string} */ () => {
	return `Braun`
};

const en_main_colors_brown5 = /** @type {(inputs: {}) => string} */ () => {
	return `Brown`
};

const es_main_colors_brown5 = /** @type {(inputs: {}) => string} */ () => {
	return `Marrón`
};

const fr_main_colors_brown5 = /** @type {(inputs: {}) => string} */ () => {
	return `Marron`
};

const hu_main_colors_brown5 = /** @type {(inputs: {}) => string} */ () => {
	return `Barna`
};

const it_main_colors_brown5 = /** @type {(inputs: {}) => string} */ () => {
	return `Marrone`
};

const nl_main_colors_brown5 = /** @type {(inputs: {}) => string} */ () => {
	return `Bruin`
};

const pl_main_colors_brown5 = /** @type {(inputs: {}) => string} */ () => {
	return `Brązowy`
};

const pt_main_colors_brown5 = /** @type {(inputs: {}) => string} */ () => {
	return `Marrom`
};

const sv_main_colors_brown5 = /** @type {(inputs: {}) => string} */ () => {
	return `Brun`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const main_colors_brown5 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.main_colors_brown5(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("main_colors_brown5", locale)
	if (locale === "cs") return cs_main_colors_brown5(inputs)
	if (locale === "da") return da_main_colors_brown5(inputs)
	if (locale === "de") return de_main_colors_brown5(inputs)
	if (locale === "en") return en_main_colors_brown5(inputs)
	if (locale === "es") return es_main_colors_brown5(inputs)
	if (locale === "fr") return fr_main_colors_brown5(inputs)
	if (locale === "hu") return hu_main_colors_brown5(inputs)
	if (locale === "it") return it_main_colors_brown5(inputs)
	if (locale === "nl") return nl_main_colors_brown5(inputs)
	if (locale === "pl") return pl_main_colors_brown5(inputs)
	if (locale === "pt") return pt_main_colors_brown5(inputs)
	return sv_main_colors_brown5(inputs)
};
export { main_colors_brown5 as "main_colors.BROWN" }